// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Kx9Au","importantInfo":"styles_importantInfo__2_Kr_"};